<style scoped>
.small-table {
	font-size: 14px;
	line-height: 1.2;
	padding: 2px;
}

.small-table th, .small-table td {
	padding: 4px;
}

.small-table-card {
	padding-top: 8px;
	padding-bottom: 8px;
}
</style>
<template>
	<div>
		<div class="card mb-3">
			<div class="card-body small-table-card">
				<h4 class="">kürzliche manuelle Bestellungen</h4>
				<table class="table table-sm table-hover mb-0 small-table">
					<thead>
						<tr>
							<th>Lieferant</th>
							<th>Artikel-Id</th>
							<th>Zustand</th>
							<th>Bestellreferenz</th>
							<th>Bestellmenge</th>
							<th>Benutzer</th>
							<th>Kaufdatum</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="mh in material.materialHistory">
							<td><strong>{{ mh.stock.vendor.name }}</strong></td>
							<td>{{ mh.stock.articleId }}</td>
							<td>
								<span v-if="mh.stock.articleCondition == 1">Neu</span>
								<span v-else-if="mh.stock.articleCondition == 2">Gebraucht</span>
								<span v-else>—</span>
							</td>
							<td>{{ mh.manualOrderReference }}</td>
							<td>{{ mh.manualOrderQuantity }}</td>
							<td>{{ getUserShortname(mh.userId) }}</td>
							<td>{{ formatDate(mh.created_at) }}</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div class="card-body small-table-card mt-3">
				<h4 class="">Verkaufsstatistik</h4>
				<table class="table table-sm table-hover mb-0 small-table">
					<thead>
						<tr>
							<th>30 T</th>
							<th>90 T</th>
							<th>360 T</th>
							<th>letzter VK-Tag</th>
							<th>SKU</th>
						</tr>
					</thead>
					<tbody>
					<tr v-if="material.salesData">
						<td>{{ material.salesData.sales_30 }}</td>
						<td>{{ material.salesData.sales_90 }}</td>
						<td>{{ material.salesData.sales_360 }}</td>
						<td>{{ formatDate(material.salesData.lastSale) }}</td>
						<td>{{ material.salesData.latest_sku }}</td>
					</tr>
					</tbody>
				</table>
			</div>

		</div>
		<div v-if="material !== null"><!-- ====== Html stuff ====== -->
			<material-vendor-stock-table
					:authorization="user.authorization"
					:material="material"
					:isMaster="isMaster"
					:userName="user.name"
					@updateStock="updateStock"
			></material-vendor-stock-table>

			<div class="card mb-3">
				<div class="card-body">
					<h3>Marktplätze</h3>
					<blocker-computed-table :passed-material="passedMaterial"
					                        :blocker-computed-table-data="blockerComputedTableData"
					                        :product-categories="productCategories"/>
				</div>
			</div>

		<div class="card mb-3">
			<div class="card-body">
			<div class="mt-3 mb-2 d-flex align-items-center justify-content-between">
				<h3 class="my-2 mb-0">Live Listings</h3>
				<b-btn
					@click="showLiveListingsErrorModal = true"
					:disabled="listingsErrors == null || listingsErrors?.length === 0"
				>
					Fehler Codes
				</b-btn>
			</div>
			<template v-if="liveListingsMarkets?.length > 0">
				<table class="table table-sm table-hover mb-3">
					<thead>
					<tr class="">
						<th scope="col"></th>
						<th scope="col">Seller</th>
						<th scope="col" title="Menge">LSt</th>
						<th scope="col" title="Zustand">Zst</th>
						<th scope="col">Vendor</th>
						<th scope="col">Seller</th>
						<th scope="col" title="Competitive Price Threshold / Price Star">CPT/PS</th>
						<th scope="col">FBA</th>
						<th scope="col">min</th>
						<th scope="col">VK</th>
						<th scope="col">max</th>
						<th scope="col">Status</th>
					</tr>
					</thead>
					<tbody>
					<template v-for="(marketplace, marketplaceIndex) in liveListingsMarkets" >
							<LiveListingsMarketPlace
									v-if="marketplace.marketData"
									:passed-market-index="marketplaceIndex"
									:passed-mm-data="passedMaterial.marketMirrorData"
									:passed-marketplace-data="marketplace"
									:passedAsin="material.asin"
									:passedEan="material.ean"
							/>
					</template>
					</tbody>
				</table>
			</template>

				<table class="table table-sm table-hover">
					<thead>
					<tr style="background-color: #f8f9fa">
						<th scope="col"></th>
						<th scope="col">Land  </th>
						<th scope="col" style="width:235px">Market Account</th>
						<th scope="col">FU    </th>
						<th scope="col">LSt   </th>
						<th scope="col">Seller</th>
						<th scope="col">FBA   </th>
						<th scope="col">min   </th>
						<th scope="col">VK    </th>
						<th scope="col">max   </th>
						<th scope="col">PS    </th>
					</tr>
					</thead>
					<tbody>
					<template v-for="stock in syncLiveListings" :key="stock.id">
						<sync-live-listing-row
								v-for='(mas, i) in stock.marketaccountstocks'
								:key="i"
								:stock="stock"
								:live-listing="mas"
								:total-row-span="stock.marketaccountstocks.length"
								:row-index="i"
								:passed-asin="material.asin"
								:passed-ean="material.ean"
						/>
					</template>
					</tbody>
				</table>

				</div>
			</div>
			<b-modal
					id="errorCodesModal"
					v-model="showLiveListingsErrorModal"
					title="Fehlermeldungen"

			>
				<div v-for="errors in listingsErrors">
					<span v-html="'<b>' + errors.marketIdentifier + ' - ' + errors.sellerIdentifier + '</b><br>'"></span>
					<div v-if="errors?.commands">
						<span  v-for=" command in errors?.commands" v-html="'SKU: ' +command.sku + ' -  Stock-ID: ' + command.stockId + ' - Zustand: ' + getConditionName(command) + '<br>'"></span>
						<span v-for="error in errors.codeErrors" v-html="error.code + ' - ' + error.description + '<br>'" style="color: red"></span>
					</div>
					<div v-else-if="errors?.listing">
						<span>SKU: {{errors.listing?.sku}} - Stock-ID: {{errors.listing?.stockId}} - Zustand: {{getConditionName(errors.listing)}}</span><br>
						Fehler vom: {{ moment(errors.codeErrors.timestamp).format('DD.MM.YYYY HH:mm:ss') }} <br>
						<div v-if="Array.isArray(errors.codeErrors.submissionError) && errors.codeErrors.submissionError.length > 0">
									<span v-for="error in errors.codeErrors.submissionError" style="color: red">
										{{ error.code }} - {{ error.message ?? error.description}}<br>
									</span>
						</div>
						<div v-else>
							<span style="color: red">{{ errors.codeErrors.submissionError }} </span>
						</div>
					</div>
				</div>
				<template #modal-footer>
					<b-button
							variant="secondary"
							size="sm"
							@click="showLiveListingsErrorModal = false"
					>Schließen</b-button>
				</template>
			</b-modal>
			<modal-error-component v-model="modalError"></modal-error-component>
		</div>
	</div>
</template>
<script>
import SyncLiveListingRow from "./materialStockLiveListing/SyncLiveListingRow.vue"
import ModalErrorComponent from "../ModalErrorComponent.vue";
import LiveListingsMarketPlace from "./materialStockLiveListing/LiveListingsComponents/LiveListingsMarketPlace.vue";

export default {
	components: {
		LiveListingsMarketPlace,
		SyncLiveListingRow,
		ModalErrorComponent,
	},
	props: ['passedMaterial', 'isMaster', 'user', "users", "blockerComputedTableData", "synchMarkets", "productCategories"],
	data() {
		return {
			regexLagerPattern: new RegExp("^Lager[0-9]{1,}$|^Ausschussware$"),
			stockSaveProcessing: 0,
			material: this.passedMaterial,
			master: this.isMaster,
			highPriceMarkets: [],
			highPriceVirtualStocks: [],
			highPriceMarketTableConfig: {
				fields: [
					{key: 'name', label: 'Name'}
				]
			},
			modalError: {
				show: false,
				title: 'Speichern',
				error: '',
				message: 'Der Speichervorgang konnte aufgrund eines Fehlers nicht durchgeführt werden.'
			},
			tHeight: (window.innerHeight - 200),
			RowKeyNumber: 0,
			showLiveListingsErrorModal: false,
			sellerIdentifier:  ["MUL", "COS", "LDD", "WRM"],
			syncLiveListings: [],
		}
	},
	watch: {
		material: {
			handler() {
				this.initSyncMarketPlaces();
			},
			immediate: true,
		},
		synchMarkets: {
			handler() {
				this.initSyncMarketPlaces();
			},
			immediate: true,
		},
	},
	computed: {
		liveListingsMarkets() {
			if (this.material === null || this.material?.cpeData == null || this.synchMarkets == null) {
				return;
			}
			return this.material.cpeData.map(item => {
				return {
					...item,
					marketData: this.synchMarkets.find(market => {
						if (item.marketIdentifier === "BOL-NL") {
						return market.mdsMarketIdentifier === "BOL-NL" && market.id === 40;
						}
					return market.mdsMarketIdentifier === item.marketIdentifier;
					})
				}
			}).filter(marketplace => Object.keys(marketplace.listings ?? {})?.length > 0
			|| Object.keys(marketplace.commands ?? {})?.length > 0
			|| Object.keys(marketplace.priceStarInfo ?? {})?.length > 0).sort((a, b) => {
				if (a.marketData && b.marketData) {
					return a.marketData.market.name.localeCompare(b.marketData.market.name);
				}
				return 0;
			});
		},
		listingsErrors(){
			if (this.material === null || this.material?.cpeData == null) return [];
			const errors = []
			//delayed ADDs
			this.material.cpeData?.forEach(marketPlace => {
	      Object.keys(marketPlace?.commands)?.forEach(sellerIdentifier => {
		      Object.keys(marketPlace?.commands[sellerIdentifier]).forEach(condition => {
            if (marketPlace?.commands[sellerIdentifier][condition].codeErrors.length > 0) {
	            errors.push({
		            marketIdentifier: marketPlace.marketIdentifier,
		            sellerIdentifier: sellerIdentifier,
		            commands: marketPlace?.commands[sellerIdentifier][condition].commands,
								codeErrors: marketPlace?.commands[sellerIdentifier][condition].codeErrors,
	            });
            }
		      })
				})
			});
			//ListingsErrors
			this.material.cpeData.forEach(data => {
				Object.entries(data.listings || {}).forEach(([sellerIdentifier, listingsByCondition]) => {
					Object.entries(listingsByCondition || {}).forEach(([condition, listingsArray]) => {
						listingsArray.forEach(listing => {
							if (listing.errors?.length > 0) {
								errors.push({
									marketIdentifier: data.marketIdentifier,
									sellerIdentifier: sellerIdentifier,
									listing,
									codeErrors: this.getLatestError(listing.errors),
								});
							}
						});
					});
				});
			});
			return errors;
		},
	},
	methods: {
				/**
		 * groups array of objects by a specific key-value pair.
		 * @param xs: array<T>
		 * @param k: string,  such that: k <- Object.keys(T)
		 * @return { ...key: array<T> }
		 */
		groupBy: function (xs, key) {
			return xs.reduce(function (rv, x) {
				(rv[x[key]] = rv[x[key]] || []).push(x);
				return rv;
			}, {});
		},

		updateStock(stocks) {
			// console.log(stocks);
			stocks.forEach(_stock => {
				this.material.stocks.forEach(stock => {
					if (stock.id === _stock.id) {
						stock = _stock;
					}
				})
			});
		},
		getUserShortname(id) {
			const user = this.users.find(user => user.id === id)
			return user ? user.shortname : '—';
		},
		filterMarketAccountStocks(){
			return this.material.stocks.filter(stock => stock.marketaccountstocks.length > 0)
		},
		getMarketPlaceName(marketIdentifier) {
			if (!this.synchrotronMarkets) {
				return '—';
			}
			const market = this.synchrotronMarkets.find(market => market.mdsMarketIdentifier === marketIdentifier)
			return market ? market.name : '—';
		},
		getMarketId(marketIdentifier) {
			if (!this.synchrotronMarkets) return;
			const market = this.synchrotronMarkets.find(market => market.mdsMarketIdentifier === marketIdentifier)
			return market ? market.id : null;
		},
		formatDate(date) {
			return new Date(date).toLocaleDateString('de-DE');
		},
		getConditionName(command) {
			if (!command) {
				return "—";
			}
			if (command?.condition == 1) {
				return "N";
			} else if (command?.condition == 2 && command?.newAsUsed === false) {
				return "SH";
			} else if (command?.condition == 2 && command?.newAsUsed === true) {
				return "SF";
			}
		},
		getLatestError(errors) {
			if (!errors || errors.length === 0) {
				return [];
			}

			const latest = errors.reduce((prev, current) => {
				return (prev.timestamp > current.timestamp) ? prev : current;
			});

			return latest;
		},
		initSyncMarketPlaces(){
			if (!this.material?.marketMirrorIds || !this.synchMarkets) {
				console.log('No marketMirrorIds or synchMarkets found');
				return [];
			}
			const mirrorKeys = this.material.marketMirrorIds;
			const filteredStocks = this.material.stocks
					.filter(stock => stock.marketaccountstocks.length > 0)
					.map(stock => ({
						...stock,
						marketaccountstocks: stock.marketaccountstocks
								.filter(listing => !mirrorKeys.includes(String(listing?.marketaccount?.id)))
								.sort((a, b) => (b?.priceInfoHistories?.[0]?.priceState ?? 0) - (a?.priceInfoHistories?.[0]?.priceState ?? 0))
					}));

			this.syncLiveListings = filteredStocks;
		}
	},

	created() {
		// prepare they currency symbol for Stocks, this is in  the wrong place. Already calculated somewhere.
		// Dollwar sign is missing however

		for (let stock of this.material.stocks) {
			for (let masx of stock.marketaccountstocks) {
				masx.currencyIso = masx.marketaccount.country.currencyIso;
				if (masx.currencyIso == undefined) {
					masx.currencyIso = "EUR";
				}
				// +++ Currency Symbol data prep
				if (masx.currencyIso == "EUR") {
					masx.currencySymbol = '€';
				} else if (masx.currencyIso == "USD") {
					masx.currencySymbol = '$';
				} else if (masx.currencyIso == "BPB" || masx.currencyIso == "GBP") {
					masx.currencySymbol = "£";
				} else {
					masx.currencySymbol = masx.currencyIso;
				}

				// +++ split priceCalcLog into array:
				masx.priceCalcLog = masx.priceCalcLog.split('\n');
				// load log into json object:
				let pcl = {};
				let k = 0;
				for (let p of masx.priceCalcLog) {
					pcl[k++] = p.split(':');
				}
				masx.priceCalcLog = pcl;

			}
			stock.marketaccountstocks.sort((v, w) => {
				return v.marketaccount.country.countryIso.localeCompare(w.marketaccount.country.countryIso)
			});
		}
	}
}
</script>
